__turbopack_context__.v({
  "close-button": "o-toast-module-scss-module__0VzZRq__close-button",
  "headline": "o-toast-module-scss-module__0VzZRq__headline",
  "image": "o-toast-module-scss-module__0VzZRq__image",
  "placeholder": "o-toast-module-scss-module__0VzZRq__placeholder",
  "section": "o-toast-module-scss-module__0VzZRq__section",
  "wrapper": "o-toast-module-scss-module__0VzZRq__wrapper",
});
